var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col- ml-4"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fa fa-arrow-left mr-4",staticStyle:{"cursor":"pointer"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }